import { Alert, Link } from '@mui/material';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

/** Where a booking sync is run (Settings › Sync Bookings; Ops › Sync Bookings is the same page). */
export const SYNC_BOOKINGS_PATH = '/settings/sync-bookings';

export const SANDBOX_SYNC_NOTE = 'This is a sandbox: bookings are not pulled automatically; run a booking sync when needed.';

/** A sandbox pulls no bookings from its booking system on a schedule (backend ESB: SANDBOX_PULL off); mirrored
 *  webhooks and a booking sync run by hand bring them in. `linked`: offer the Sync Bookings page. */
const SandboxSyncNote = ({ linked = false, sx }: { linked?: boolean; sx?: object }) => (
    <Alert severity="info" sx={{ my: 1, ...sx }} data-testid="sandbox-sync-note">
        {SANDBOX_SYNC_NOTE}
        {linked && (
            <>
                {' '}
                <Link component={RouterLink} to={SYNC_BOOKINGS_PATH}>Sync bookings</Link>
            </>
        )}
    </Alert>
);

export default SandboxSyncNote;
